import { IAppState, TActions } from '../../common/state';
import { EPriceType, jq } from '../../json_query';
import { FOfferType } from '../../utils/category';

import { OFFER_TYPE_SELECTED } from './offer_type';

export interface IPriceTypeChangedAction {
  type: 'filters/priceType/PRICE_TYPE_CHANGED';
  priceType: EPriceType;
}

export function setPriceType(priceType: EPriceType): IPriceTypeChangedAction {
  return {
    type: 'filters/priceType/PRICE_TYPE_CHANGED',
    priceType,
  };
}

export function priceTypeReducer(state: IAppState, action: TActions): IAppState {
  const jsonQuery = jq(state.filters.jsonQuery);

  switch (action.type) {
    case 'filters/priceType/PRICE_TYPE_CHANGED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jsonQuery.setPriceType(action.priceType),
        },
      };

    case OFFER_TYPE_SELECTED: {
      const offerType = action.offerType;

      if (offerType !== FOfferType.Coworking) {
        return state;
      }

      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: {
            ...state.filters.jsonQuery,
            price_sm: undefined,
          },
        },
      };
    }
    default:
      return state;
  }
}
